import { DoubleArrowRightIcon } from '@radix-ui/react-icons';
import { PlayerIconButton } from './SmartPlayerUI';
import { useFastForwardControl } from '../hooks/usePlayerControls';
import { useTranslation } from 'react-i18next';

export const SmartPlayerFastForward = () => {
    const { t } = useTranslation('smartPlayer');
    const { currentRate, isActive, handleFF } = useFastForwardControl();
    return (
        <PlayerIconButton
            active={isActive}
            onClick={handleFF}
            style={{ width: '32px' }}
            title={t('controls.fast_forward')}
        >
            {isActive ? (
                `${currentRate}x`
            ) : (
                <DoubleArrowRightIcon width='18' height='18' />
            )}
        </PlayerIconButton>
    );
};
